<template>
    <div>
        <mini-input :value.sync="item.entityFrom" type="select"
                    :optionsFromDict="DICT_TYPE"
                    select-dict-text
                    label="视图选择"
                    @change="getForm"/>
        <b-overlay :show="loading" spinner-small spinner-variant="secondary">
            <mini-input :value.sync="item.entityFromByKey" type="select"
                        :options="formOfEntity"
                        label="ByKey"/>
        </b-overlay>
    </div>
</template>

<script>
import MiniInput from "@/components/common/inputs/MiniInput.vue";
import {DICT_TYPE} from "@/plugins/configure-query-helper";

export default {
    name: "EntityFromConfig",
    components: {MiniInput},
    props: {
        item: Object
    },
    data() {
        return {
            formOfEntity: [],
            loading: false,
        }
    },
    computed: {
        DICT_TYPE() {
            return DICT_TYPE
        },
    },
    mounted() {
        if (this.item.entityFrom) {
            this.getForm(this.item.entityFrom);
        }
    },
    methods: {
        getForm(code) {
            this.loading = true;
            this.$queryIdByCode(code).then(res => {
                let id = res.id;
                this.$store.dispatch('api/get', {
                    url: `${process.env.VUE_APP_EM_ASSISTANT_URL}/qg/view/form?id=${id}`
                }).then(res => {
                    let form = res.form;
                    if (form) {
                        this.toOptions(form);
                    }
                }).finally(() => this.loading = false);
            }).finally(() => this.loading = false);
        },
        toOptions(form) {
            let tempList = [];
            for (let item of form) {
                tempList.push({
                    value: item.key,
                    text: item.key
                });
            }
            this.formOfEntity = tempList;
        },
    }
}
</script>

<style scoped>

</style>
